import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MeasurementUnit } from 'app/models/measurement-unit/measurement-unit';
import { CartProduct } from 'app/models/product/cart-product/cart-product';
import { SimpleProduct } from 'app/models/product/product/simple-product';
import { AbstractHttpService } from '../base/abstract.http.service';
import { ORDERS_CART } from '../base/service-const';
import { take } from 'rxjs/operators';
import { CartItem } from 'app/models/cart/cart-item';
import { Observable } from 'rxjs';
import { AppConfigService } from '../app-config/app-config.service';

@Injectable({
  providedIn: 'root',
})
export class CartService extends AbstractHttpService<any> {

  //defaultMeasurementUnit: MeasurementUnit = {id: -1, defaultUnit: true, description: 'UNIDADE', indexPrice: 1, measurementInitials: 'UN', quantity: 1};

  cartSize: number = 0;

  disabledButton: boolean = false;

  constructor(
    protected _httpClient: HttpClient,
    private appConfigService: AppConfigService
  ) {
    super(_httpClient, ORDERS_CART, appConfigService.apiBaseUrl);

  }

  clearCart(): Observable<any> {
    return this.customDelete('cart').pipe(take(1));
  }

  updateProduct(product: SimpleProduct, measurementUnit: MeasurementUnit, operation: string, quantity?: number, fromCart?: boolean): Observable<any> {
    var cartItem = new CartItem();
    cartItem.productCode = product.id;
    cartItem.productClasCode = product.classificationId;
    cartItem.quantity = quantity ?? 1;
    cartItem.measurementUnit = measurementUnit.measurementInitials;
    if (!fromCart) {
      cartItem.price = +(((product.offerPrice == 0 ? product.price : product.offerPrice) * measurementUnit.indexPrice) * (measurementUnit.quantity ?? 1)).toFixed(4);
    } else {
      cartItem.price = (product.offerPrice == 0 ? product.price : product.offerPrice);
    }
    cartItem.operation = operation;
    cartItem.measurementUnitQuantity = measurementUnit.quantity;
    return this.create(cartItem).pipe(take(1));
  }

  getCart(): Observable<any> {
    return this.customList('cart').pipe(take(1));
  }

  loadCartSize() {
    return this.customList('cart').pipe(take(1)).subscribe((data: any) => {
      if (data != null && data.data[0] != null)
        this.cartSize = data.data[0].itens.length;
    })
  }

}
